import { graphql, HttpResponse } from 'msw';
import { FanReactionType, type PostFanContentMutation } from '@/__generated__/graphql';

export const postFanContent = graphql.mutation<PostFanContentMutation>('PostFanContent', (req) => {
  const { input } = req.variables;
  const { body, channelID, isSpoiler, parentContentID } = input;
  const isRegistered = true;

  const newPost = {
    __typename: 'FanPost' as const,
    ulid: `mock-fan-post-${Date.now()}`,
    body,
    channelID,
    isSpoiler,
    isMasked: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),

    fan: {
      __typename: 'Fan' as const,
      id: 'fan-001',
      name: 'モックユーザー',
      iconImage: null,
    },

    reactions: {
      __typename: 'FanPostReactions' as const,
      reactionCounts: [
        { __typename: 'FanReactionCount' as const, type: FanReactionType.Like, count: 1 },
      ],
      artistReactions: [],
      myReactions: isRegistered
        ? [
            {
              __typename: 'FanReaction' as const,
              id: 'reaction-001',
              type: FanReactionType.Like,
            },
          ]
        : null,
    },

    superMessageInfo: null,

    parentContent: parentContentID
      ? {
          __typename: 'ArtistPost' as const,
          channelID,
          ulid: parentContentID,
          body: 'アーティスト投稿モックアーティスト投稿モックアーティスト投稿モックアーティスト投稿モックアーティスト投稿モックアーティスト投稿モック',
          isSpoiler: false,
          isMasked: false,
          artistOfficial: {
            __typename: 'ArtistOfficial' as const,
            id: 'artist-parent',
            iconImage: null,
          },
        }
      : null,
  };

  return HttpResponse.json({
    data: {
      __typename: 'Mutation',
      postFanContent: {
        __typename: 'PostFanContentPayloadSuccess' as const,
        ok: true,
        post: newPost,
      },
    },
  });
});
